import React, { Component } from 'react';
import {
  Container,
  Header,
  Button,
  Form,
  Message,
  Grid
} from 'semantic-ui-react';
import Recaptcha from 'react-recaptcha';

const onloadCallback = () => {};
class Contact extends Component {
  state = {
    email: '',
    nom: '',
    sujet: '',
    message: '',
    res: {},
    errors: {}
  };
  verifyCallback = response => {
    this.sendForm(response);
  };

  handleSubmit = () => {
    const { errors, ...fields } = this.state;
    const newErrors = {};
    Object.keys(fields).forEach(key => {
      switch (key) {
        case 'email':
          const emailValid = fields[key].match(
            /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
          );
          if (!emailValid) newErrors.email = 'Email invalide';
          break;
        case 'nom':
          if (fields[key] === '') newErrors.nom = 'Veuillez entrez votre nom';
          break;
        case 'sujet':
          if (fields[key] === '') newErrors.sujet = 'Veuillez entrez un sujet';
          break;
        case 'message':
          if (fields[key] === '')
            newErrors.message = 'Veuillez entrez un message';
          break;
        default:
          break;
      }
    });
    if (Object.keys(newErrors).length === 0) {
      this.captchaRef.execute();
    }
    this.setState({ errors: newErrors });
  };
  sendForm = captchaRes => {
    const { errors, ...fields } = this.state;
    fetch('https://paraphe.online/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ ...fields, captchaRes })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          this.setState({
            res: { success: true },
            email: '',
            nom: '',
            tel: '',
            sujet: '',
            message: '',
            errors: {}
          });
        } else {
          this.setState({ res: { success: false, error: data.error } });
        }
      });
  };
  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };
  handleBlur = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  render() {
    return (
      <div id="contact_form">
        <div
          style={{
            padding: '3em',
            backgroundColor: 'rgba(0,0,0,0.5)',
            minHeight: '90vh'
          }}
        >
          <Container
            textAlign="center"
            id="app"
            style={{ paddingBottom: '3em' }}
          >
            <Header as="h2" style={{ padding: '2em 0', color: 'white' }}>
              Contactez nous
            </Header>
            <Form
              id="contactForm"
              success={this.state.res.success === true}
              error={
                Object.keys(this.state.errors).length !== 0 ||
                this.state.res.success === false
              }
            >
              <Grid stackable columns={2}>
                <Grid.Column>
                  <Form.Input
                    error={!!this.state.errors.email}
                    name="email"
                    icon="at"
                    iconPosition="left"
                    placeholder="Email"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                  />
                  <Form.Input
                    error={!!this.state.errors.nom}
                    iconPosition="left"
                    icon="user"
                    name="nom"
                    placeholder="Nom et prénom"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                  />
                  <Form.Input
                    error={!!this.state.errors.sujet}
                    iconPosition="left"
                    icon="envelope"
                    name="sujet"
                    placeholder="Sujet de l'email"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                  />
                </Grid.Column>
                <Grid.Column stretched>
                  <Form.TextArea
                    error={!!this.state.errors.message}
                    name="message"
                    style={{
                      height: '142px',
                      resize: 'none'
                    }}
                    placeholder="Votre Message"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                  />
                </Grid.Column>
              </Grid>

              <Message
                success
                header="Message envoyé"
                content="Merci de nous avoir contacté, nous vous répondrons dans les plus brefs délais"
              />
              <Message
                error
                header={
                  this.state.res.error
                    ? this.state.res.error.map(err => <p> {err} </p>)
                    : 'Veuillez remplir les champs requis et/ou entrer un email valide'
                }
              />
            </Form>
            <Button
              primary
              style={{ marginTop: '2em' }}
              onClick={this.handleSubmit}
              disabled={this.state.res && this.state.res.success}
            >
              Envoyer le message
            </Button>
          </Container>
          <Recaptcha
            ref={captcha => {
              this.captchaRef = captcha;
            }}
            sitekey="6Le1bksUAAAAAEQMDJw1R3ofTJnkAOTF-e8tAoCg"
            size="invisible"
            render="explicit"
            badge="inline"
            verifyCallback={this.verifyCallback}
            onloadCallback={onloadCallback}
          />
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js